module.exports = __webpack_public_path__ + "img/wattler.8b96d72b.jpg";